export enum ApplicationStatus {
  ACCEPTED = 'Accepted',
  SUBMITTED = 'Submitted',
}
